import { BrandLockup } from "./BrandLockup";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin, ShieldAlert } from "lucide-react";
import { FOOTER_COLUMNS } from "../lib/nav";

export default function Footer() {
  return (
    <footer className="bg-[#155e3f] text-white mt-12" data-testid="site-footer">
      <div className="border-b border-white/10 bg-[#155e3f]">
        <div className="dk-container py-5 flex flex-col md:flex-row md:items-center gap-4 text-sm" data-testid="anti-fraud-notice">
          <ShieldAlert className="text-[#d6aa43] shrink-0" size={22} aria-hidden="true" />
          <p className="flex-1 leading-relaxed"><span className="text-white font-semibold">Applying for support is free.</span> Dutsen Kauna Foundation does not charge applicants to submit or process support applications. Never pay anyone who claims they can guarantee approval.</p>
          <Link to="/complaints#fraud" className="dk-btn-outline !py-2 !px-4 text-xs whitespace-nowrap self-start md:self-auto" data-testid="footer-report-fraud">Report fraud / impersonation</Link>
        </div>
      </div>

      <div className="dk-container py-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
        <div className="col-span-2 md:col-span-3 lg:col-span-1">
          <div className="mb-5">
            <BrandLockup tone="dark" size="md" />
          </div>
          <p className="text-sm leading-relaxed">Community development and humanitarian support in Nigeria — verified needs, traceable projects, transparent reporting.</p>
        </div>
        {FOOTER_COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="font-serif text-white text-base mb-4">{col.title}</h4>
            <ul className="space-y-2 text-sm">
              {col.links.map(([label, to]) => <li key={label}><Link to={to} className="hover:text-[#f0ce77] inline-block py-0.5" data-testid={`footer-${label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}>{label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="dk-container py-8 grid md:grid-cols-3 gap-6 text-sm">
          <div>
            <div className="text-white font-semibold">Dutsen Kauna Foundation</div>
            <div className="text-xs mt-1">Registered non-profit organisation, Nigeria. Registration details are published on our <Link to="/governance-and-transparency#registration" className="underline hover:text-[#f0ce77]">Trust &amp; Transparency</Link> page.</div>
          </div>
          <ul className="space-y-2">
            <li className="flex gap-2"><Phone size={15} className="text-[#d6aa43] mt-0.5" /> <a href="tel:+2348063550963" className="hover:text-[#f0ce77]">+234 806 355 0963</a></li>
            <li className="flex gap-2"><Mail size={15} className="text-[#d6aa43] mt-0.5" /> <a href="mailto:foundation@dutsenkauna.org" className="hover:text-[#f0ce77] break-all">foundation@dutsenkauna.org</a></li>
            <li className="flex gap-2"><MapPin size={15} className="text-[#d6aa43] mt-0.5" /> <span><span className="text-white font-semibold">Head Office:</span> Dutsen Kauna, Abuja-FCT, Nigeria</span></li>
          </ul>
          <div className="flex md:justify-end items-start gap-3">
            {[[Facebook, "Facebook"], [Instagram, "Instagram"], [Twitter, "X"], [Linkedin, "LinkedIn"]].map(([Icon, l]) => (
              <a key={l} href="#" aria-label={l} className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#d6aa43] hover:text-[#d6aa43] transition-colors"><Icon size={16} /></a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="dk-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <div>© {new Date().getFullYear()} Dutsen Kauna Foundation. All rights reserved. <Link to="/admin/login" className="ml-3 text-white/90 hover:text-[#d6aa43] underline-offset-4 hover:underline" data-testid="footer-staff-login">Staff Login</Link></div>
          <div className="tracking-[0.25em] uppercase text-[#d6aa43] font-semibold text-center">Innovation • Impact • Integrity • Love</div>
        </div>
      </div>
    </footer>
  );
}
